export const prettifyMediaName = ({ name }: { name: string }) => {
  let prettierMediaName = name;

  // Handle the Readspeaker generated audio names
  if (prettierMediaName.length > 4 && prettierMediaName.includes(".oga")) {
    prettierMediaName = prettierMediaName.split(".oga")[0];
  }
  return prettierMediaName;
};
